module.exports = __webpack_public_path__ + "static/gallery-13-4354ec7467229214c1e8494704f3278f.jpg";